<template>
  <div class="chart-container">
    <div style="height: 36px;line-height: 36px;background: var(--theme-header);color: var(--theme-label);display: flex;margin-bottom: 6px;cursor: pointer;">
        <div v-for="(i,idx) in tabList" @click="tabChange(idx)" :class="chartTabIndex == idx?'home_zs_box home_zs_active':'home_zs_box'">{{i.title }}</div>
    </div>
    <div ref="minute" style="height: 100%;"></div>
  </div>
</template>

<script>
import DefaultData from '@/utils/DefaultData.js'
import JSHQDataAllTX from '@/utils/tencent.data.js'
import HQChart from "hqchart";
import { applyChartPricePrecision } from '@/utils/chartPricePrecision';
import { applyChartTheme } from '@/utils/chartTheme';
import { pollMarket, marketRequest, MARKET_REFRESH_MS, publicBody } from '@/utils/marketRefresh'

export default {
    props: {
        active: { type: Boolean, default: true },
        marketPolling: { type: Boolean, default: false },
        width: {
            type: Number,
            default: 0
        },
        height: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
          chartTabIndex: 0,
          symbol:'000001.sh',
          tabList: [
            {title: "上证指数"},
            {title: "深证指数"},
            {title: "创业板指"}
          ],
          SymbolCodes: [
            "000001.sh",
            "399001.sz",
            "399006.sz"
          ],
            Minute: {
                JSChart: null,
                Option: DefaultData.GetMinuteOption(),
            }
        }
    },
    watch: {
        active(value) { if (value) this.$nextTick(this.activate); else this.stopPolling() },
        width() { this.$nextTick(this.OnSize) },
        height() { this.$nextTick(this.OnSize) },
        '$store.state.quoteColorMode'() { applyChartTheme(this.Minute.JSChart, this.$store.state.theme); },
        '$store.state.theme'(theme) { applyChartTheme(this.Minute.JSChart, theme); }
    },
    mounted() {
        window.addEventListener('resize', this.OnSize);
        this.$nextTick(this.activate)
    },
    beforeDestroy() { this.disposed = true; this.stopPolling(); window.removeEventListener('resize', this.OnSize); if (this.Minute.JSChart) this.Minute.JSChart.ChartDestroy() },
    methods: {
        stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
        activate() {
            if (this.disposed || !this.active || this.stopRefresh) return
            this.OnSize()
            if (this.Minute.JSChart) this.requestMinute()
            else this.createChart()
            this.stopRefresh = pollMarket(() => this.requestMinute(), this.marketPolling ? MARKET_REFRESH_MS : 2000, 'cn')
        },
        requestMinute() {
            if (this.disposed || !this.active) return
            return this.Minute.JSChart.JSChartContainer.RequestMinuteData()
        },
        tabChange(index) {
          if(this.chartTabIndex != index){
            this.chartTabIndex = index
            this.symbol = this.SymbolCodes[this.chartTabIndex]
            if(this.Minute.JSChart){
                this.Minute.JSChart.ChartDestroy()
                const dom = this.$refs.minute
                while(dom.hasChildNodes()){
                        dom.removeChild(dom.lastChild)
                    }
                this.Minute.JSChart=null;
                this.OnSize();        
                this.createChart()         
            }
          }
          
        },
        OnSize()
        {
            this.getSize();
            if (this.Minute.JSChart) this.Minute.JSChart.OnSize();
        },
        async NetworkFilter(data, callback)
        {
            //console.log('[HQChartDemo::NetworkFilter]chart data', data);
            if (this.disposed || !this.active || document.hidden) { data.PreventDefault = true; return }
            data.Request.Data.symbol = this.symbol
            if (this.marketPolling && data.Name === 'MinuteChartContainer::RequestMinuteData') {
                data.PreventDefault = true
                if (this.minuteLoading) return
                this.minuteLoading = true
                const code = this.symbol.slice(-2) + this.symbol.slice(0, -3)
                try {
                    const result = publicBody(await marketRequest('minute', { code }, !this.minuteLoaded))
                    if (this.disposed || !this.active || data.Self.IsDestroy) return
                    if (!result || !result.data || !result.data[code] || !result.data[code].data) throw new Error('分时返回异常')
                    this.minuteLoaded = true
                    JSHQDataAllTX.RecvMinuteData(result, data, callback, { InternalSymbol: code, Symbol: this.symbol })
                } catch (_) { if (!data.Self.IsDestroy) callback({ code: 0, stock: [] }) }
                finally { this.minuteLoading = false }
                return
            }
            JSHQDataAllTX.NetworkFilter(data, callback)
        },
        createChart() {
            //if (this.Minute.JSChart) return;
            this.Minute.Option.Symbol=this.symbol;
            this.Minute.Option.symbol=this.symbol;
            this.minuteLoaded = false
            // The component owns polling, so hiding it can physically stop all updates.
            this.Minute.Option.IsAutoUpdate = false
            applyChartTheme(null, this.$store.state.theme);
            let chart=HQChart.Chart.JSChart.Init(this.$refs.minute);
            this.Minute.Option.NetworkFilter = this.NetworkFilter;
            chart.SetOption(this.Minute.Option);
            applyChartPricePrecision(chart);
            this.Minute.JSChart=chart;
        },
        getSize() {
            // var tabs = this.$refs['tabs'];
            // var chartHeight = tabs.offsetHeight;
            // var chartWidth = tabs.offsetWidth - 22;
            var minute=this.$refs.minute;
            minute.style.width = this.width-25+'px';
            minute.style.height = this.height+'px';
        }
    }
};
</script>

<style lang="scss">
.chart-container {
    width: 100%;
    height: 100%;
}
.home_zs_box{
  width: 120px;
  text-align: center;
}
.home_zs_active{
    color: var(--theme-text);
    //border-bottom: 2px solid #fff !important;
}
</style>
